module.exports = __webpack_public_path__ + "img/suhao.92182fa4.jpg";